import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 15;
`;

export const Position = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
`;

export const Notice = styled.div`
  display: flex;
  width: 85%;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;
  font-family: "Inter", sans-serif;
  color: ${({ theme }) => theme.THEME.white};
  text-align: center;
  justify-content: center;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 5}px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
